import axios, { AxiosResponse } from 'axios';
import type { ResourceSearchResponse } from '@/venit/services/model/techpubs-cms';

export type SearchCategory = 'FULL_TEXT' | 'PART' | 'RESOURCE_NAME' | 'PUBLICATION_CONTENT';

export default class ApiSearchService {
  public search(
    query: string,
    category: SearchCategory,
    lang: string,
    page: number,
    size: number,
  ): Promise<AxiosResponse<ResourceSearchResponse>> {
    const params = new URLSearchParams({
      q: query,
      category,
      lang,
      page: String(page),
      size: String(size),
    });
    return axios.get<ResourceSearchResponse>(`/api/v1/search?${params}`);
  }
}
